/**
 * WhatsApp utility functions for redirecting to WhatsApp with phone numbers
 */

/**
 * Formats a phone number for WhatsApp URL
 * Removes spaces, plus signs, and common formatting characters
 */
export const formatPhoneForWhatsApp = (phone) => {
    // Remove all non-digit characters except country code (+)
    let cleaned = phone.replace(/[^\d+]/g, '');

    // If starts with +40, it's Romanian - remove the + and format
    if (cleaned.startsWith('+40')) {
        cleaned = cleaned.replace('+', '');
    }

    return cleaned;
};

/**
 * Generates WhatsApp URL with optional predefined message
 */
export const generateWhatsAppUrl = (phoneNumber, message = '') => {
    const formattedPhone = formatPhoneForWhatsApp(phoneNumber);
    let whatsappUrl = `https://wa.me/${formattedPhone}`;

    if (message) {
        const encodedMessage = encodeURIComponent(message);
        whatsappUrl += `?text=${encodedMessage}`;
    }

    return whatsappUrl;
};

/**
 * Opens WhatsApp in a new tab/window for the given phone number
 */
export const openWhatsApp = (phoneNumber, message = '') => {
    const whatsappUrl = generateWhatsAppUrl(phoneNumber, message);

    // Open in new tab
    window.open(whatsappUrl, '_blank', 'noopener,noreferrer');

    // If it's a mobile device, we could try to open the app directly
    // but browsers usually handle this automatically
};

/**
 * Romanian predefined welcome message for medical context
 */
export const getMedicalWelcomeMessage = () => {
    return 'Bună ziua! Am văzut site-ul Evoo Medical și aș vrea să vă contactez pentru informații despre programările medicale.';
};
